import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { InquiryFieldUpdate, InquiryForm, Project } from '../../project-data';

@Component({
  selector: 'app-inquiry-modal',
  imports: [FormsModule],
  templateUrl: './inquiry-modal.component.html',
})
export class InquiryModalComponent {
  @Input({ required: true }) inquiry!: InquiryForm;
  @Input({ required: true }) messageError = false;
  @Input({ required: true }) messageSending = false;
  @Input({ required: true }) messageSent = false;
  @Input({ required: true }) projects: Project[] = [];
  @Output() readonly closed = new EventEmitter<void>();
  @Output() readonly fieldUpdated = new EventEmitter<InquiryFieldUpdate>();
  @Output() readonly inquirySent = new EventEmitter<void>();

  protected update(field: keyof InquiryForm, value: string): void {
    this.fieldUpdated.emit({ field, value });
  }
}
